import APIConnector from "../lib/APIConnector";
import Settings from '../base/Settings'
const apiConnector = new APIConnector({ timeout: 30000 })

export default class PlaceConfig {
  static get endpoint(){
    return Settings.SERVICE_DOMAIN
  }
  static get endpointPlaces() {
    return `${PlaceConfig.endpoint}/places`;
  }
  static get endpointSavePlace() {
    return `${PlaceConfig.endpointPlaces}/save`;
  }
  static get endpointDeletePlace() {
    return `${PlaceConfig.endpointPlaces}/delete`;
  }

  static get APIConnector() {
    return apiConnector
  }
}



// WEBPACK FOOTER //
// ./src/provider/place/PlaceConfig.js